import React from "react";
import { getUrl } from "../../helpers/Pipes";

import { ErroriTemplate } from "../../templates/ErroriTemplate/ErroriTemplate";

export const NotFoundPage = () => {
  return (
    <ErroriTemplate
      iconName={"error"}
      titleLabel={"Pagina non trovata"}
      textLabel={"Pagina non trovata..."}
      buttonLabel={"Torna all'inizio"}
      linkUrlButton={getUrl("home")}
    />
  );
};
